export default __webpack_public_path__ + "static/media/a012-market-line-10.66aa93db.svg";